export default "__VITE_ASSET__BWzHM3F5__"